function injectStyle (ssrContext) {
  require("!!../../../../node_modules/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-535d113f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=styles&index=0!./apiServerDefined.vue")
}
var Component = require("!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./apiServerDefined.vue"),
  /* template */
  require("!!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-535d113f\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./apiServerDefined.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/modules/00299303/apiServerDefined.vue
// module id = T/0X
// module chunks = 1